// extracted by mini-css-extract-plugin
export default {"ruleset__text--button":"styles_ruleset__text--button__S-cId"};